<template>
  <div class="slider-item" :style="itemStyle">
    <slot />
  </div>
</template>

<script setup lang="ts">
import { computed, inject, onMounted, ref, type ComputedRef, type Ref } from 'vue';

const activeIndex = inject<Ref<number>>('blockSliderActiveIndex', ref(0));
const register = inject<() => number>('blockSliderRegister', () => 0);
const speed = inject<ComputedRef<number>>(
  'blockSliderSpeed',
  computed(() => 1000)
);

const slideIndex = ref(0);

onMounted(() => {
  slideIndex.value = register();
});

const isActive = computed(() => activeIndex.value === slideIndex.value);

const itemStyle = computed(() => ({
  zIndex: isActive.value ? 99 : 98,
  transition: `all ${speed.value / 1000}s`,
  display: isActive.value ? undefined : 'none',
}));
</script>
